import React from 'react';

function Instagram() {
  return (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76.50571 76.50571">
      <title>Instagram</title>
      <path d="M38.25285,0A38.25285,38.25285,0,1,0,76.50571,38.25285,38.252,38.252,0,0,0,38.25285,0Zm0,71.56932A33.31646,33.31646,0,1,1,71.56932,38.25285,33.31581,33.31581,0,0,1,38.25285,71.56932Z" fill="#bdbebf" />
      <path d="M38.61711,28.83023a9.55434,9.55434,0,0,1,6.83062,2.86124H57.37567V26.82384h.00185a7.41027,7.41027,0,0,0-7.411-7.40912H29.715V28.7561H28.19665V19.41472H27.3182c-.05784,0-.11392.00185-.17176.00361V28.7561H25.62813V19.61a7.29152,7.29152,0,0,0-1.07.338V28.7561H23.038V20.77764a7.39727,7.39727,0,0,0-3.13064,6.0462v4.86763H31.78826A9.55331,9.55331,0,0,1,38.61711,28.83023ZM47.606,23.70042a1.18756,1.18756,0,0,1,1.18931-1.18755h4.00547a1.18876,1.18876,0,0,1,1.1894,1.18755v4.09589a1.18882,1.18882,0,0,1-1.1894,1.18755H48.79529A1.18762,1.18762,0,0,1,47.606,27.79631Z" fill="#bdbebf" />
      <path d="M43.48113,32.86458a7.46368,7.46368,0,0,0-1.81658-1.17311,7.36485,7.36485,0,0,0-6.09312,0,7.39,7.39,0,1,0,7.9097,1.17311ZM38.64238,43.87613a5.45876,5.45876,0,1,1,5.45881-5.45881A5.45856,5.45856,0,0,1,38.64238,43.87613Z" fill="#bdbebf" />
      <path d="M27.3182,57.07833H49.96655a7.41177,7.41177,0,0,0,7.411-7.41089V32.86458H46.431a9.58806,9.58806,0,1,1-15.62607,0H19.90733V49.66744A7.41169,7.41169,0,0,0,27.3182,57.07833Z" fill="#bdbebf" />
    </svg>
  );
}

export default Instagram;



// WEBPACK FOOTER //
// ./client/components/shared/SocialMediaLinks/icons/Instagram.js